import {
    Box, Checkbox, Flex,
    Heading, HStack, Input, Radio, RadioGroup, Stack,
    Text, Textarea, useBoolean, useBreakpointValue,
    useDisclosure,
    VStack
} from "@chakra-ui/react";
import {CustomCheckbox, InputLabel, PaginationRow, StyledButton} from "../../../components";
import React, {useState} from "react";
import {ReactComponent as Close} from "../../../assets/icons/CloseButton.svg";
import {ReactComponent as Delete} from "../../../assets/icons/profile/delete_icon.svg";
import {ReactComponent as Edit} from "../../../assets/icons/profile/edit.svg";
import {ReactComponent as Back} from "../../../assets/icons/back.svg";
import {ReactComponent as CloseTag} from "../../../assets/icons/tagCloase.svg";
import {Screener} from "../../../helpers/data-jsons";
import {CustomSelectExchanges} from "../../../components/theme/select/CustomSelectExchanges";
import {Link} from "react-router-dom";

const AddNotifications = ({setActiveTab}) => {
    const isMobile = useBreakpointValue({base: true, md: false, lg: false})
    const [value, setValue] = useState('buy_and_sell');
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(2);
    return (
        <VStack
            color={'neutral.100'}
            w={'100%'}>
            <Box
                w={'full'}
                p={{base: '16px', md: '16px 32px'}}
                bg={'neutral.1100'}
                borderRadius={{base: '0', md: '16px'}}
                display={'flex'}
                flexDirection={'column'}
                gap={'24px'}
            >
                <Flex
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    p={{base: '16px 10px', md: '11px 0'}}
                    w={'100%'}
                >
                    <Flex alignItems={'center'}
                          justifyContent={'space-between'}
                          w={'100%'}
                    >
                        <Heading
                            display={'flex'}
                            alignItems={'center'}
                            color={'neutral.100'}
                            gap={'4px'}
                            fontSize={'heading.3xl'}>
                            <Box
                                cursor={'pointer'}
                                onClick={() => setActiveTab('notifications')}
                            ><Back/></Box><span>Notification template</span>
                        </Heading>
                        <Box
                            cursor={'pointer'}
                            onClick={() => setActiveTab('notifications')}
                        ><Close/></Box>
                    </Flex>
                </Flex>
                <HStack>
                    <Box
                        w={'full'}
                        display={'flex'}
                        flexWrap={'wrap'}
                        flexDirection={'column'}
                        gap={'12px'}
                        justifyContent={'space-between'}
                        maxW={'530px'}
                    >
                        <Text color={'neutral.600'}>Template name</Text>
                        <Input
                            minH={'40px'}
                            border={'none'}
                            borderRadius={'8px'}
                            bg={'neutral.900'}
                            type={'text'}
                            label={'Name'}
                            maxW={'565px'}/>
                    </Box>
                </HStack>
                <Box
                    bg={'neutral.900'}
                    p={'16px'}
                    borderRadius={'8px'}
                    gap={'8px'}
                    display={'flex'}
                    flexWrap={'wrap'}
                >
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >volume<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >profitIndexMin<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >sellPriceAvg<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >profitIndexAvg<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >profitIndexAvg<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >profitIndexAvg<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >minConfirm<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >minConfirm<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >minConfirm<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >volume<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >profitIndexAvg<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >profitIndexAvg<CloseTag/></StyledButton>
                    <StyledButton
                        gap={'4px'}
                        width={'max-content'}
                        maxHeight={'20px'}
                        bg={'#5834A8'}
                        fontWeight={'400'}
                        fontSize={'12px'}
                        fontSizeBase={'12px'}
                    >profitIndexAvg<CloseTag/></StyledButton>
                </Box>
                <Heading
                    fontWeight={'500'}
                    fontSize={'16px'}
                >The following variables are available in the template</Heading>
                <Box
                    bg={'neutral.1000'}
                    gap={'16px'}
                    padding={'10px 16px'}
                    borderRadius={'8px'}
                    display={'flex'}
                    flexDirection={'column'}
                >
                    <Box
                        p={'0 12px'}
                        gap={'8px'}
                        borderBottom={'solid 1px #353945'}
                        display={'flex'}
                        alignItems={'center'}
                        minH={'32px'}
                    >
                        <Heading fontSize={'14px'}>Profit Variables</Heading>
                    </Box>
                    <Flex
                        justifyContent={'space-between'}
                    >
                        <Flex gap={'16px'} alignItems={'center'}>
                            <StyledButton fontSize={'12px'} bg={'transparent'} fontSizeBase={'12px'} height={'20px'}
                                          border={'solid 1px #5834A8'}>profitIndexMax</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Maximum profit percentage</Text>
                        </Flex>
                        <Flex gap={'16px'} alignItems={'center'}>
                            <StyledButton fontSize={'12px'} bg={'transparent'} fontSizeBase={'12px'} height={'20px'}
                                          border={'solid 1px #5834A8'}>profitIndexMin</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Minimum profit percentage</Text>
                        </Flex>
                        <Flex gap={'16px'} alignItems={'center'}>
                            <StyledButton fontSize={'12px'} bg={'transparent'} fontSizeBase={'12px'} height={'20px'}
                                          border={'solid 1px #5834A8'}>profitIndexAvg</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Average profit percentage</Text>
                        </Flex>
                    </Flex>
                </Box>
                <Box
                    bg={'neutral.1000'}
                    gap={'16px'}
                    padding={'10px 16px'}
                    borderRadius={'8px'}
                    display={'flex'}
                    flexDirection={'column'}
                >
                    <Box
                        p={'0 12px'}
                        gap={'8px'}
                        borderBottom={'solid 1px #353945'}
                        display={'flex'}
                        alignItems={'center'}
                        minH={'32px'}
                    >
                        <Heading fontSize={'14px'}>Volume & Exchange</Heading>
                    </Box>
                    <Flex
                        justifyContent={'space-between'}
                        flexWrap={'wrap'}
                    >
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} margin={'4px 0'} fontSizeBase={'12px'} fontSize={'12px'} bg={'transparent'}
                                          height={'20px'} border={'solid 1px #5834A8'}>volume</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>General volume</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} margin={'4px 0'} fontSizeBase={'12px'} fontSize={'12px'} bg={'#23262F'}
                                          height={'20px'} border={'none'}>exchangeSell</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Selling exchange</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} margin={'4px 0'} fontSizeBase={'12px'} fontSize={'12px'} bg={'transparent'}
                                          height={'20px'} border={'solid 1px #5834A8'}>volumeUsd</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Volume in USD</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} margin={'4px 0'} fontSizeBase={'12px'} fontSize={'12px'} bg={'#23262F'}
                                          height={'20px'} border={'none'}>exchangeBuy</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Buying exchange</Text>
                        </Flex>
                    </Flex>
                </Box>
                <Box
                    bg={'neutral.1000'}
                    gap={'16px'}
                    padding={'10px 16px'}
                    borderRadius={'8px'}
                    display={'flex'}
                    flexDirection={'column'}
                >
                    <Box
                        p={'0 12px'}
                        gap={'8px'}
                        borderBottom={'solid 1px #353945'}
                        display={'flex'}
                        alignItems={'center'}
                        minH={'32px'}
                    >
                        <Heading fontSize={'14px'}>Price Variables</Heading>
                    </Box>
                    <Flex
                        justifyContent={'space-between'}
                        flexWrap={'wrap'}
                    >
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton bg={'#23262F'} maxWidth={'110px'} fontSizeBase={'12px'} fontSize={'12px'} margin={'4px 0'}
                                          height={'20px'} border={'none'}>buyPriceMin</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Min buying price</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} fontSize={'12px'}  fontSizeBase={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>buyPriceAvg</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Avg buying price</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} fontSize={'12px'} fontSizeBase={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>buyPriceMax</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Max buying price</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton fontSize={'12px'} bg={'transparent'} fontSizeBase={'12px'} maxWidth={'110px'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>sellPriceMin</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Min selling price</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} fontSize={'12px'} fontSizeBase={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>sellPriceMax</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Max selling price</Text>
                        </Flex>
                        <Flex ap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} fontSize={'12px'} fontSizeBase={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>sellPriceAvg</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Avg selling price</Text>
                        </Flex>
                    </Flex>
                </Box>
                <Heading
                    fontWeight={'500'}
                    fontSize={'16px'}>The following variables are available for networks</Heading>
                <Box
                    bg={'neutral.1000'}
                    gap={'16px'}
                    padding={'10px 16px'}
                    borderRadius={'8px'}
                    display={'flex'}
                    flexDirection={'column'}
                >
                    <Box
                        p={'0 12px'}
                        gap={'8px'}
                        borderBottom={'solid 1px #353945'}
                        display={'flex'}
                        alignItems={'center'}
                        minH={'32px'}
                    >
                        <Heading fontSize={'14px'}>Networks & Fees</Heading>
                    </Box>
                    <Flex
                        justifyContent={'space-between'}
                        flexWrap={'wrap'}
                    >
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton fontSizeBase={'12px'} fontSize={'12px'} maxWidth={'110px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>chainsBuy</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Withdraw networks</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} fontSizeBase={'12px'} fontSize={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>withdrawEnabled</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Withdrawal status</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton maxWidth={'110px'} fontSizeBase={'12px'} fontSize={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>chainsSell</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Network name</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton bg={'transparent'} maxWidth={'110px'} fontSizeBase={'12px'} fontSize={'12px'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>depositEnabled</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Deposit status</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton fontSize={'12px'} maxWidth={'110px'} fontSizeBase={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>withdrawFee</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Withdrawal fee</Text>
                        </Flex>
                        <Flex gap={'43px'} w={'277px'} alignItems={'center'}>
                            <StyledButton fontSize={'12px'} maxWidth={'110px'} fontSizeBase={'12px'} bg={'transparent'} margin={'4px 0'}
                                          height={'20px'} border={'solid 1px #5834A8'}>minConfirm</StyledButton>
                            <Text fontSize={'12px'} color={'neutral.500'}>Min number of confirmations</Text>
                        </Flex>
                    </Flex>
                </Box>
                <HStack>
                    <Box
                        w={'full'}
                        display={'flex'}
                        flexDirection={'row'}
                        justifyContent={'end'}
                        gap={'24px'}
                    >
                        <StyledButton maxHeight={'40px'} fontSize={'16px'} bg={'#6F41D240'}>Delete</StyledButton>
                        <StyledButton maxHeight={'40px'} fontSize={'16px'} bg={'#5834A8'}>Save</StyledButton>
                    </Box>
                </HStack>
            </Box>
        </VStack>

    )
}
export default AddNotifications